import { API_URL, Status } from '../constants';
import { fetch } from '../fetchWrapper/fetch';

export interface ITriggerVenueSyncResponse {
  event_id: string;
}

export const triggerVenueSync = async (): Promise<ITriggerVenueSyncResponse> => {
  try {
    const res = await fetch(`${API_URL}/venues/sync`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!res.ok || res.status !== Status.ACCEPTED) {
      const result = await res.json();
      throw new Error(result.message);
    }

    return await res.json();
  } catch (e) {
    if (e) {
      throw new Error(e.message);
    } else {
      throw new Error('Could not sync venues');
    }
  }
};
